import RoleTag from './RoleTag.component';

export default RoleTag;
